module.exports = __webpack_public_path__ + "img/logo-new.1dfb4c15.svg";